import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import './index.css';
import { ErrorPage, Home, Parts, Protocols,  Description, HumanPractices, Education, Team , Game, Attribution, Contribution, Engineering, Experiments, Notebook, Results, Safety, Awards, ProductPage,Events, BSGV, Acknowledgement} from './component';
import reportWebVitals from './reportWebVitals';
import { DescriptionKids, EngineeringKids, ExperimentsKids, ResultsKids } from './component/Kids';



const router = createBrowserRouter([
  {
    path: "/epfl",
    element: <Home />,
    errorElement: <ErrorPage />
  },
  {
    path: "/epfl/home",
    element: <Home />,
    errorElement: <ErrorPage />
  },
  {
    path:"/epfl/description",
    element: < Description/>,
    errorElement: <ErrorPage />
  },
  {
    path:"/epfl/human-practices",
    element: < HumanPractices/>,
    errorElement: <ErrorPage />
  },
  {
    path:"/epfl/education",
    element: < Education />,
    errorElement: <ErrorPage />
  },
  {
    path:"/epfl/BSGV",
    element: < BSGV />,
    errorElement: <ErrorPage />
  },
  {
    path:"/epfl/team",
    element: < Team />,
    errorElement: <ErrorPage />
  },
  {
    path:"/epfl/game",
    element: < Game/>,
    errorElement: <ErrorPage />
  },
  {
    path: "/epfl/attributions",
    element: <Attribution />,
    errorElement: <ErrorPage />
  },
  {
    path: "/epfl/contribution",
    element: <Contribution />,
    errorElement: <ErrorPage />
  },
  {
    path: "/epfl/engineering",
    element: <Engineering />,
    errorElement: <ErrorPage />
  },
  {
    path: "/epfl/experiments",
    element: <Experiments />,
    errorElement: <ErrorPage />
  },
  {
    path: "/epfl/notebook",
    element: <Notebook />,
    errorElement: <ErrorPage />
  },
  {
    path: "/epfl/results",
    element: <Results />,
    errorElement: <ErrorPage />
  },
  {
    path: "/epfl/safety",
    element: <Safety/>,
    errorElement: <ErrorPage />
  },
  {
    path: "/epfl/awards",
    element: <Awards/>,
    errorElement: <ErrorPage />
  },
  {
    path: "/epfl/acknowledgements",
    element: <Acknowledgement/>,
    errorElement: <ErrorPage />
  },
  {
    path: "/epfl/home",
    element: <Home/>,
    errorElement: <ErrorPage />
  },
  {
    path: "/epfl/user-friendly/description",
    element: <DescriptionKids />,
    errorElement: <ErrorPage />
  },
  {
    path: "/epfl/userfriendly/game",
    element: <Game/>,
    errorElement: <ErrorPage />
  },
  {
    path: "/epfl/user-friendly/engineering",
    element: <EngineeringKids />,
    errorElement: <ErrorPage />
  },
  {
    path: "/epfl/user-friendly/experiments",
    element: <ExperimentsKids />,
    errorElement: <ErrorPage />
  },
  {
    path: "/epfl/user-friendly/results",
    element: <ResultsKids />,
    errorElement: <ErrorPage />
  },
  {
    path:"/epfl/product-page",
    element: < ProductPage/>,
    errorElement: <ErrorPage />
  },
  {
    path:"/epfl/events",
    element: < Events/>,
    errorElement: <ErrorPage />
  },
 
  {
    path: "/epfl/parts",
    element: <Parts />,
    errorElement: <ErrorPage />
  },
  {
    path: "/epfl/protocols",
    element: <Protocols />,
    errorElement: <ErrorPage />
  }

]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router}  basename={process.env.PUBLIC_URL}/>
  </React.StrictMode>
);

reportWebVitals();
